export default "__VITE_ASSET__CTCbXHOM__"